module.exports = __webpack_public_path__ + "fonts/Inter-100-greek-ext3.318d4ba.woff2";